module.exports = __webpack_public_path__ + "media/painPoint.262b7983.mp4";